module.exports = __webpack_public_path__ + "static/media/metamask_right.a0103549.svg";